/**
 * 目标推送：任务定向名册解析（指挥端 missions + 设备列表）
 */
import { missionIdMatchesMember, looksLikeGhostMissionId } from '../dashboard/deviceIdentity';

export function resolveMissionMemberKeys(mission, missionGroupId) {
  if (!mission) return [];
  const gid = String(missionGroupId || '').trim();
  if (gid) {
    const g = (mission.groups || []).find((x) => String(x.id) === gid);
    return Array.isArray(g?.memberIds)
      ? g.memberIds.map((x) => String(x || '').trim()).filter(Boolean)
      : [];
  }
  return Array.isArray(mission.memberIds)
    ? mission.memberIds.map((x) => String(x || '').trim()).filter(Boolean)
    : [];
}

/** 从 live members 解析展示姓名；用于写入 user_names */
export function resolveMissionRecipientNames(mission, missionGroupId, members = []) {
  const keys = resolveMissionMemberKeys(mission, missionGroupId);
  const list = Array.isArray(members) ? members : [];
  const names = [];
  const seen = new Set();
  keys.forEach((raw) => {
    const mid = String(raw || '').trim();
    if (!mid) return;
    let hit = null;
    list.forEach((m) => {
      if (!missionIdMatchesMember(mid, m)) return;
      if (!m?.name) return;
      hit = m;
    });
    let name = hit?.name ? String(hit.name).trim() : '';
    if (!name) {
      // 可能本身就是姓名
      if (!looksLikeGhostMissionId(mid) && !mid.includes(':') && /[\u4e00-\u9fff]/.test(mid)) {
        name = mid;
      }
    }
    if (!name || seen.has(name)) return;
    seen.add(name);
    names.push(name);
  });
  return names;
}
